import React from 'react';
import {connect} from 'react-redux';

import {setProductJourney} from "./VisualizerManagementActions";
import CheckBox from "../PageLayout/CheckBox";

const VisualizerManagementUiSwitch = (props) => {

  const {activeTab, isProductJourney, setProductJourney} = props;

  if (activeTab === "mobile_links") {
    return null
  }

  return (
    <CheckBox checked={isProductJourney}
              onChecked={(checked) => setProductJourney(!checked)}
              text="Product Journey"/>
  )

}

const mapStateToProps = (store) => {
  const {activeTab, isProductJourney} = store.visualizerManagement;
  return {
    activeTab,
    isProductJourney
  }
}

const mapDispatchToProps = {
  setProductJourney
};

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerManagementUiSwitch);
